import "./sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import Snowfall from "react-snowfall";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthProviders from "./Providers/AuthProviders";
import AlertBannerProvider from "./Providers/AlertBannerProvider";
import { store } from "./Redux/store";
import { registerSW } from "./serviceWorkerRegistration";
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient();

// Register service worker
registerSW();

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <AlertBannerProvider>
              <AuthProviders>
                <Snowfall
                  snowflakeCount={0}
                  color="#e91e63"
                  wind={[1, 4]}
                  style={{
                    position: "fixed",
                    inset: 0,
                    pointerEvents: "none"
                  }}
                />
                <App />
                <Snowfall snowflakeCount={0} />
              </AuthProviders>
            </AlertBannerProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
